import React from 'react';
import { Outlet } from 'react-router-dom';
import PlannerSidebar from '../components/PlannerSidebar';
import '../component-styles/PlannerSidebar.css';

export default function Planner() {
  return (
    <div className="planner-root-page">
      <PlannerSidebar />

      <div className="planner-main" style={{ padding: 16 }}>
        <Outlet />
      </div>
    </div>
  );
}
